import { useContext } from 'react'
import { Footer } from 'antd/es/layout/layout'
import { StyledButton, StyledButtonsContainer } from './CustomFooter.styles'
import { CustomFooterProps } from './CustomFooter.types'
import { LayoutContext } from 'contexts'

const CustomFooter = ({ handleSave, loading }: CustomFooterProps) => {
  const { sideBarWidth } = useContext(LayoutContext)
  return (
    <Footer
      style={{
        backgroundColor: '#fff',
        position: 'fixed',
        bottom: 0,
        left: `${sideBarWidth}px`,
        right: 0,
        width: '100%',
        padding: '0 40px',
        borderTop: '1px solid #a8d6ea',
      }}
    >
      <StyledButtonsContainer sideBarWidth={sideBarWidth}>
        <StyledButton loading={loading} onClick={handleSave}>
          Save Changes
        </StyledButton>
      </StyledButtonsContainer>
    </Footer>
  )
}

export default CustomFooter
